import style from './article-preview-small.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { IArticle } from '@models/article.interface';
import ReadingTimeBlock from '@components/blog/reading-time-block/reading-time';


interface IArticlePreviewSmallProps {
    article: IArticle
}

const ArticlePreviewSmall = ({article}: IArticlePreviewSmallProps) => {
    
    return (
        <div className={style.article__item}>
            <div className={style.article__item__image}>
                <Link href={`/blog/${article.slug}`}>
                    <a>
                        <Image sizes="1024px" layout={'fill'} src={article.posterUrl} alt={article.header}/>
                    </a>
                </Link>
            </div>
            <div className={style.article__item__content}>
                <div className={style.article__item__title}>
                    <Link href={`/blog/${article.slug}`}>
                        <a>
                            {article.header}
                        </a>
                    </Link>
                </div>
                <ReadingTimeBlock readingTime={article.readingTime} articleLabel={article.label} />
            </div>
        </div>
    )
}

export default ArticlePreviewSmall;
